import useTranslation from 'next-translate/useTranslation';
import Head from 'next/head';
import { LinkProps } from 'next/link';
import { FunctionComponent, useEffect } from 'react';

import useSchemaBreadcrumbs from '../../../../utils/seo/schema-org/breadcrumbs';
import useSchemaWebPage from '../../../../utils/seo/schema-org/webpage';
import { useAppContext } from '../../../providers/app-context';
import useSchema from '../../../../utils/seo/schema-org/schema';
import useLinkProps from '../../../../hooks/use-link-props';
import cleanFAQs from '../../../../utils/cleanFaqs';

const FaqGroupSchema: FunctionComponent<{
  faqsOfGroup: TFaqsByGroup;
  breadcrumbs: Array<{
    href: LinkProps;
    text: string;
  }>;
}> = ({ breadcrumbs, faqsOfGroup }) => {
  const { t } = useTranslation();
  const { businessValues } = useAppContext();
  const getLink = useLinkProps();

  const name = t('faqs:head.title_by_group', {
    group: faqsOfGroup.group.label,
  });

  const description = t('faqs:head.description', {
    totalStockAvailable: businessValues.totalStockAvailable.defaultValue,
  });

  const breadcrumbFaqs = [{ ...getLink('faqs'), text: t('common:faqs') }];
  const cleanFaqs = cleanFAQs(faqsOfGroup.faqs);
  return (
    <Head>
      <title>{name}</title>
      <meta name="description" content={description} />

      <script {...useSchemaWebPage({ name, description })} />
      <script {...useSchemaBreadcrumbs({ breadcrumbs: breadcrumbFaqs })} />
      <script {...useSchema({
        name,
        description,
        breadcrumbs: breadcrumbFaqs,
        extraSchema: [
          {
            '@type': 'FAQPage', // All of the following faqs should be translated to the respective property "inLanguage" presented above
            about: {
              '@type': 'Thing',
              name: `${t('common:faqs')} - ${faqsOfGroup.group.label}`,
            },
            mainEntity: [
              ...cleanFaqs,
            ],
          },
        ],
      })} />
    </Head>
  );
};

export default FaqGroupSchema;
